import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconClipboardUserProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconClipboardUser = ({ ...props }: IconClipboardUserProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 384 512"
    version="1.1"
    title="Cog"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z" />
    </g>
  </MySvgIcon>
)
